export const SOCIAL_BUTTON_ICON_SIZE = 20;

export type SocialProvider = 'google' | 'facebook' | 'apple';
